module.exports = __webpack_public_path__ + "img/kefu.c0da8d55.gif";